import { apiClient, bearer, unwrap } from './client';
import type { CustomerListOut, CustomerOut, components } from './types';

export function listCustomers(idToken: string): Promise<CustomerListOut> {
  return apiClient
    .GET('/api/customers', { headers: bearer(idToken) })
    .then(unwrap<CustomerListOut>);
}

export function getCustomerBySlug(slug: string, idToken: string): Promise<CustomerOut> {
  return apiClient
    .GET('/api/customers/{slug}', {
      params: { path: { slug } },
      headers: bearer(idToken),
    })
    .then(unwrap<CustomerOut>);
}

export type CustomerCreateInput = components['schemas']['CustomerCreateIn'];

export function createCustomer(
  input: CustomerCreateInput,
  idToken: string,
): Promise<CustomerOut> {
  return apiClient
    .POST('/api/customers', {
      body: input,
      headers: bearer(idToken),
    })
    .then(unwrap<CustomerOut>);
}

export type CustomerUpdateInput = components['schemas']['CustomerUpdateIn'];

export function updateCustomer(
  slug: string,
  input: CustomerUpdateInput,
  idToken: string,
): Promise<CustomerOut> {
  return apiClient
    .PATCH('/api/customers/{slug}', {
      params: { path: { slug } },
      body: input,
      headers: bearer(idToken),
    })
    .then(unwrap<CustomerOut>);
}

export function archiveCustomer(slug: string, idToken: string): Promise<CustomerOut> {
  return apiClient
    .POST('/api/customers/{slug}/archive', {
      params: { path: { slug } },
      headers: bearer(idToken),
    })
    .then(unwrap<CustomerOut>);
}

export type CustomerUserOut = components['schemas']['CustomerUserOut'];
export type CustomerUserListOut = components['schemas']['CustomerUserListOut'];

export function listCustomerUsers(
  slug: string,
  idToken: string,
): Promise<CustomerUserListOut> {
  return apiClient
    .GET('/api/customers/{slug}/users', {
      params: { path: { slug } },
      headers: bearer(idToken),
    })
    .then(unwrap<CustomerUserListOut>);
}

export type CustomerMemberOut = components['schemas']['CustomerMemberOut'];
export type CustomerMemberListOut = components['schemas']['CustomerMemberListOut'];

/** Merged people list: accepted users (from our DB) + pending Clerk
 *  invitations. Prefer this over `listCustomerUsers` for the customer
 *  detail page — it surfaces outstanding invites, not just joined users. */
export function listCustomerMembers(
  slug: string,
  idToken: string,
): Promise<CustomerMemberListOut> {
  return apiClient
    .GET('/api/customers/{slug}/members', {
      params: { path: { slug } },
      headers: bearer(idToken),
    })
    .then(unwrap<CustomerMemberListOut>);
}

export function deleteCustomerUser(
  slug: string,
  userId: string,
  idToken: string,
): Promise<void> {
  return apiClient
    .DELETE('/api/customers/{slug}/users/{user_id}', {
      params: { path: { slug, user_id: userId } },
      headers: bearer(idToken),
    })
    .then(unwrap<void>);
}

// GL-account registry wrappers live in `gl-accounts.ts`.
